import React, { useState } from "react"
import { Grid } from "@material-ui/core"
import { Database as DatabaseIcon } from "lucide-react"
import { ActionDialog, Text, themeColors } from "letalkui"

import { renderComponent } from "@/utils/node"
import useStyles from "@/pages/Admin/ClientCatalog/ExportContactsDialog/styles"

type ExportContactsDialogProps = {
	onConfirm: () => Promise<void> | void
}

type ExportContactsDialogType = {
	open: (props: ExportContactsDialogProps) => void
}

const ExportContactsDialog: ExportContactsDialogType & React.FC<ExportContactsDialogProps> = (props) => {
	const { onConfirm } = props

	const classes = useStyles()

	const [opened, setOpened] = useState(true)

	const handleClose = () => {
		setOpened(false)
	}

	const handleSave = async () => {
		await onConfirm()
		handleClose()
	}

	return (
		<ActionDialog
			title="Deseja realmente exportar seus contatos?"
			open={opened}
			onClose={handleClose}
			onSave={handleSave}
			cancelButtonLabel="FECHAR"
			saveButtonLabel="EXPORTAR"
			shouldHaveFullWidth
		>
			<Grid container alignItems="flex-start" spacing={2} wrap="nowrap" className={classes.upsellCard}>
				<Grid item>
					<Grid className={classes.benefitIconBox}>
						<DatabaseIcon
							size={20}
							color={themeColors.getPrimaryColor()}
						/>
					</Grid>
				</Grid>
				<Grid item xs>
					<Text.Body type="default" color={themeColors.getPrimaryColor()}>
						Precisa exportar a base de todas as suas instâncias? Conte com a Letalk para realizar esse processo de forma rápida, segura e sem complicações.
					</Text.Body>
				</Grid>
			</Grid>
		</ActionDialog>
	)
}

ExportContactsDialog.open = (props: ExportContactsDialogProps) => {
	renderComponent(
		"export-contacts-dialog",
		<ExportContactsDialog
			{...props}
		/>
	)
}

export default ExportContactsDialog
